import { Badge } from '@ibsys/kit';
import { Tooltip } from '@/shared/ui';
import type { FC } from 'react';
import { cn } from '@/shared/lib';

type Props = {
  /** Метка тега — какие персональные данные скрыты (например, «Имя») */
  label: string;
  /** Исходное значение; не задано — тег нераскрываемый */
  value?: string;
};

/**
 * Оформление блока: цвет наследуется от текста реплики (currentColor), поэтому блок читается
 * одинаково и в облаке консультанта, и в облаке клиента; фон и рамка — производные того же цвета.
 * Фон и рамка нарисованы слоями под текстом с прозрачностью, а не смешиванием цвета с прозрачным:
 * браузер без color-mix() залил бы блок сплошным цветом текста, и метка стала бы невидимой. Своя
 * рамка блока снята (её место отдано отступу): блок обрезает содержимое по внутреннему краю рамки,
 * и слой рамки на её месте был бы не виден.
 */
const BADGE_CLASS_NAME =
  'relative isolate mx-0.5 px-1.75 py-px align-baseline text-2xs font-normal text-current bg-transparent border-0 ' +
  'before:absolute before:inset-0 before:-z-10 before:rounded-md before:bg-current before:opacity-10 ' +
  'after:absolute after:inset-0 after:-z-10 after:rounded-md after:border after:border-current after:opacity-40';

/**
 * Блок на месте скрытых анонимизацией персональных данных в реплике.
 * Исходное значение раскрывается по наведению и только когда оно пришло с транскриптом.
 */
export const AnonymizationTagBadge: FC<Props> = ({ label, value }) => {
  if (!value) {
    return (
      <Badge variant="secondary" outline className={BADGE_CLASS_NAME}>
        {label}
      </Badge>
    );
  }

  return (
    <Tooltip tooltip={value}>
      <Badge variant="secondary" outline className={cn(BADGE_CLASS_NAME, 'cursor-help')} tabIndex={0}>
        {label}
      </Badge>
    </Tooltip>
  );
};
